import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@authentication/services/auth.service';
import { RoutePath } from '@shared/route-path.enum';

export const authGuard = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
	const authService = inject(AuthService);
	const router = inject(Router);
	if (authService.tokenNotExpired) {
		return true;
	}
	router.navigate([RoutePath.AUTH, RoutePath.LOGIN]);
	return false;
};
